import { Component, OnInit, ViewChild, Input } from "@angular/core";
import { FormGroup, FormBuilder } from "@angular/forms";
import { BillingInvoiceEditInfo } from "../../../model/billing/billing-invoice-edit-info";
import { BillingInvoice } from "../../../model/billing/billing-invoice";
import { MatTabGroup } from "@angular/material/tabs";
import { NotificationToastService } from "../../../services/notification-toast.service";
import { InvoicePointService } from "../../../services/invoice-cash-desk/invoice-point.service";
import { ConfirmDialogService } from "../../../services/confirm-dialog.service";
import { InvoiceNumberBookPoint } from "../../../model/invoice-number-book-point";
import { BillingInvoiceItemEditInfo } from "../../../model/billing/billing-invoice-item-edit-info";
import { BillingInvoiceEditService } from "../../../services/billing/billing-invoice/billing-invoice-edit.service";
import { InvoiceType } from "../../../enums/invoice-type.enum";

@Component({
  selector: "app-billing-invoice-edit",
  templateUrl: "./billing-invoice-edit.component.html",
  styleUrls: ["./billing-invoice-edit.component.css"],
})
export class BillingInvoiceEditComponent implements OnInit {
  id: number;
  form: FormGroup;
  loading: boolean;
  showReport: boolean;
  billingInvoiceId: number;
  loadingPreBillingIvoiceItems = true;
  generated: boolean;
  loadingAction: boolean;
  editInfo: BillingInvoiceEditInfo;
  @ViewChild("tabGroup", { static: false }) tabGroup: MatTabGroup;
  @Input() enabledClientSearch: boolean;
  visibleBillingInvoiceItemEntity: boolean;
  visibleCirculacionAbierta: boolean;
  visibleBillingInvoiceItemEntityCredit: boolean;
  visibleBillingInvoiceItemManual: boolean;
  visibleIsRejectedOptions: boolean;
  visibleDatesFromTo: boolean;
  visibleBillingInvoiceAssociate: boolean;
  noDeleteItemManual: boolean;
  title: string;
  titleItems: string;
  billingItems: BillingInvoiceItemEditInfo[] = [];

  constructor(
    private formBuilder: FormBuilder,
    private notificationToastService: NotificationToastService,
    private invoicePointService: InvoicePointService,
    private confirmDialogService: ConfirmDialogService,
    private billingInvoiceEditService: BillingInvoiceEditService
  ) {
    this.title =
      billingInvoiceEditService.getInvoiceTypeId() === InvoiceType.Credit
        ? "Generación nota crédito"
        : "Generación factura";

    this.titleItems =
      billingInvoiceEditService.getInvoiceTypeId() === InvoiceType.Credit
        ? "Conceptos débitos"
        : "Detalle factura";

    this.noDeleteItemManual = billingInvoiceEditService.noDeleteItemManual();

    this.visibleCirculacionAbierta =
      billingInvoiceEditService.isVisibleCirculacionAbierta();

    this.visibleDatesFromTo = billingInvoiceEditService.isVisibleDatesFromTo();

    this.visibleBillingInvoiceItemEntity =
      billingInvoiceEditService.isVisibleBillingInvoiceItemEntity();

    this.visibleBillingInvoiceItemEntityCredit =
      billingInvoiceEditService.isVisibleBillingInvoiceItemEntityCredit();

    this.visibleIsRejectedOptions =
      billingInvoiceEditService.isVisibleIsRejectedOptions();

    this.visibleBillingInvoiceItemManual =
      billingInvoiceEditService.isVisibleBillingInvoiceItemManual();

    this.visibleBillingInvoiceAssociate =
      billingInvoiceEditService.isVisibleBillingInvoiceAssociate();

    this.form = this.formBuilder.group({
      BillingInvoice: [null],
      Items: [null],
    });

    this.form.controls.Items.valueChanges.subscribe((items) => {
      const billingInvoice = <BillingInvoice>(
        this.form.getRawValue().BillingInvoice
      );
      this.billingInvoiceEditService
        .calculateBillingInvoice(billingInvoice, items)
        .then((calculateBillingInvoice) => {
          console.log("CALCULATE", calculateBillingInvoice.InvoiceTaxes);
          this.form.patchValue({ BillingInvoice: calculateBillingInvoice });
        })
        .catch((err) => {
          this.notificationToastService.error(
            JSON.stringify(err),
            "Facturación"
          );
        });
    });
  }

  async ngOnInit() {
    this.loading = true;
    this.editInfo =
      await this.billingInvoiceEditService.getBillingInvoiceEditInfo();
    const billingInvoice = new BillingInvoice();
    billingInvoice.Amount = this.editInfo.Amount;
    billingInvoice.Description = "";
    billingInvoice.InvoiceDate = this.editInfo.InvoiceDate;
    billingInvoice.InvoiceExpiredDate = this.editInfo.InvoicExpiredDate;
    //billingInvoice.InvoiceTaxes = this.editInfo.InvoiceTaxes;
    billingInvoice.TaxpayerType = this.editInfo.TaxpayerType;
    billingInvoice.ClientSearch = this.editInfo.ClientSearch;
    billingInvoice.OriginalAmount = this.editInfo.OriginalAmount;
    billingInvoice.OriginalIIBBTaxAliquotId =
      this.editInfo.OriginalIIBBTaxAliquotId;
    billingInvoice.OriginalInvoiceNumberBookTypeId =
      this.editInfo.OriginalInvoiceNumberBookTypeId;
    billingInvoice.OriginalBillingInvoiceId =
      this.editInfo.OriginalBillingInvoiceId;
    billingInvoice.OriginalBillingInvoiceManualId =
      this.editInfo.OriginalBillingInvoiceManualId;

    this.billingItems =
      await this.billingInvoiceEditService.getBillingInvoiceItemEditInfos();

    this.form.patchValue({ BillingInvoice: billingInvoice });

    this.loading = false;
  }

  onLoaded() {
    this.loadinItems();
  }

  async generate() {
    try {
      if (this.form.valid) {
        this.loadingAction = false;
        if (this.validate()) {
          await this.resolveInvoiceNumber();
        }
      }
    } catch (err) {
      console.log(err);
      this.notificationToastService.error(
        JSON.stringify(err.error),
        "Facturación"
      );
    } finally {
      this.loadingAction = false;
    }
  }

  private validate(): boolean {
    const billingInvoice = <BillingInvoice>(
      this.form.getRawValue().BillingInvoice
    );

    if (!billingInvoice.BillingInvoicePeriod) {
      this.notificationToastService.error(
        "Debe ingresar el período",
        "Facturación"
      );
      return false;
    }

    if (!billingInvoice.ClientSearch) {
      this.notificationToastService.error(
        "Debe seleccionar un cliente",
        "Facturación"
      );
      return false;
    }

    if (this.visibleDatesFromTo) {
      if (!billingInvoice.InvoiceFrom) {
        this.notificationToastService.error(
          "Debe ingresar la fecha de inicio",
          "Facturación"
        );
        return false;
      }

      if (!billingInvoice.InvoiceTo) {
        this.notificationToastService.error(
          "Debe ingresar la fecha de fín",
          "Facturación"
        );
        return false;
      }
    }

    if (this.visibleIsRejectedOptions && billingInvoice.IsRejected == null) {
      this.notificationToastService.error(
        "No se ha seleccionado si el comprobante asociado se encuentra rechazado por el comprador",
        "Facturación"
      );
      return false;
    }

    return true;
  }

  private async resolveInvoiceNumber() {
    const invoiceNumberBookPoint = await this.getNextInvoiceNumber();
    if (invoiceNumberBookPoint) {
      this.showConfirmBillingInvoiceDialog(invoiceNumberBookPoint);
    } else {
      this.notificationToastService.error(
        "No se encontró talonario para realizar la factura",
        "Generación de factura"
      );
    }
  }

  private showConfirmBillingInvoiceDialog(
    invoiceNumberBookPoint: InvoiceNumberBookPoint
  ) {
    const billingInvoice = <BillingInvoice>(
      this.form.getRawValue().BillingInvoice
    );
    this.confirmDialogService
      .confirm(
        "Generación de factura",
        "Se generará la factura: " +
          invoiceNumberBookPoint.Number +
          "<br /> Punto de venta: " +
          billingInvoice.InvoicePoint.Name,
        "Aceptar",
        "Cancelar"
      )
      .subscribe(async (result) => {
        if (result) {
          await this.billingInvoiceCreate(invoiceNumberBookPoint);
        }
      });
  }

  async billingInvoiceCreate(invoiceNumberBookPoint: InvoiceNumberBookPoint) {
    try {
      this.loadingAction = true;

      const billingInvoice = <BillingInvoice>(
        this.form.getRawValue().BillingInvoice
      );
      const items = <BillingInvoiceItemEditInfo[]>this.form.getRawValue().Items;

      const response =
        await this.billingInvoiceEditService.billingInvoiceCreate(
          billingInvoice.ClientSearch,
          invoiceNumberBookPoint,
          billingInvoice,
          null,
          items
        );

      if (response.ResponseMessage) {
        this.notificationToastService.info(
          response.ResponseMessage,
          "Generación de factura"
        );
      }

      this.billingInvoiceId = response.BillingInvoiceId;
      this.showReport = true;
    } catch (err) {
      this.notificationToastService.error(
        JSON.stringify(err.error),
        "Generación de factura"
      );
    } finally {
      this.loadingAction = false;
    }
  }

  async selectedTabChange($event) {
    if ($event.index === 1 && this.loadingPreBillingIvoiceItems) {
      await this.loadinItems();
    }
  }
  async loadinItems() {
    try {
      if (this.loadingPreBillingIvoiceItems) {
        this.form.patchValue({ Items: this.billingItems });
      }
    } catch (err) {
      this.notificationToastService.error(
        JSON.stringify(err.error),
        "Facturación"
      );
    } finally {
      this.loadingPreBillingIvoiceItems = false;
    }
  }

  close() {
    history.back();
  }

  private async getNextInvoiceNumber() {
    const billingInvoice = <BillingInvoice>(
      this.form.getRawValue().BillingInvoice
    );
    let amount = billingInvoice.Amount;
    if (
      billingInvoice.InvoiceTaxes != null &&
      billingInvoice.InvoiceTaxes.length > 0
    ) {
      billingInvoice.InvoiceTaxes.forEach((item) => {
        amount += item.Amount;
      });
    }

    return await this.invoicePointService.getNextInvoiceNumberByParameters(
      billingInvoice.InvoicePoint.Id,
      this.billingInvoiceEditService.getInvoiceTypeId(),
      billingInvoice.InvoiceLabelType.Id,
      amount,
      billingInvoice.OriginalInvoiceNumberBookTypeId,
      billingInvoice.ClientSearch.Id
    );
  }

  onClientChange() {
    const billingInvoice = <BillingInvoice>(
      this.form.getRawValue().BillingInvoice
    );
    this.calculateAmounts();
  }

  onInvoicePointChange() {
    this.calculateAmounts();
  }

  private calculateAmounts() {
    const billingInvoice = <BillingInvoice>(
      this.form.getRawValue().BillingInvoice
    );
    const items = <BillingInvoiceItemEditInfo[]>this.form.getRawValue().Items;
    if (items) {
      this.billingInvoiceEditService
        .calculateBillingInvoice(billingInvoice, items)
        .then((calculateBillingInvoice) => {
          this.form.patchValue({ BillingInvoice: calculateBillingInvoice });
        });
    }
  }
}
